import type { ActionContext } from 'vuex';
import type { RootState } from '@/store';
import { $http } from '@/utils/https';

interface State {}

const state: State = {};

const getters = {};

interface ISubscribePayload {
  email: string;
  recaptcha_token: string;
}

const actions = {
  async SUBSCRIBE(_ctx: ActionContext<State, RootState>, payload: ISubscribePayload) {
    return await $http.post('v1/esputnik/users/subscribe', payload);
  }
};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
